<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>

<div class="create-hierarchy-header">
	<ng-container *ngIf="selectedTemplate; else noTemplateAvailable;">
		<div id="edit-toggle-div">
			Edit Hierarchy : <mat-slide-toggle color="accent" [(ngModel)]="canEditHierarchy" id="edit-hierarchy-toggle"
				(change)="editHierarchyToggle()"></mat-slide-toggle>
		</div>

		<div class="header-dropdowns-row">
			<!-- Show this div when edit is enabled -->
			<!-- <div class="value-selection-container" *ngIf="canEditHierarchy; else disableHierarchyEdit">
				<div id="placeholders-div-main">
					<div class="box" *ngFor="let hierarchy of selectedTemplate.hierarchies">
						<p class="hierarchy-header headers-placeholder">{{ getPlaceholderForHierarchy(hierarchy) }}</p>
					</div>
				</div>
				<p class="hierarchy-header headers" style="margin-right: 145px;">{{ getPlaceholderForHierarchy(selectedTemplate.hierarchies[0]) }}</p>

				<div *ngFor="let hierarchyOption of selectedTemplate.hierarchies[0].values; let i = index" class="level-selection-container">
					<mat-checkbox style="width: 230px; display: unset !important;" (change)="initialHierarchySelection($event, hierarchyOption)" [checked]="isInitialHierarchySelected(hierarchyOption)">
						{{ hierarchyOption }}
					</mat-checkbox>

					<div *ngIf="isInitialHierarchySelected(hierarchyOption)">
						<app-hierarchy-checkboxes [parentName]="hierarchyOption" [selectedTemplate]="selectedTemplate" [globalIndex]="i" [organisationHierarchy]="organisationHierarchy" [currentHierarchies]="currentHierarchies" [innerIndex]="0" [parents]="[hierarchyOption]" [totalHierarchies]="totalHierarchies" [canEditHierarchy]="canEditHierarchy" (currentHierarchiesUpdateEvent)="updateCurrentHierarchies($event)"></app-hierarchy-checkboxes>
					</div>
				</div>
			</div> -->

			<!-- Show this div when edit is disabled -->

			<!-- <ng-template #disableHierarchyEdit> -->
			<div class="value-selection-container" [ngClass]="{'canEditHierarchy': canEditHierarchy, 'cannotEditHierarchy': !canEditHierarchy}" >
				<div id="placeholders-div">
					<!-- <p class="box hierarchy-header headers">{{ placeholderNonEditableHierarchy(selectedTemplate.hierarchies[0]) }}</p> -->

					<div class="box" *ngFor="let hierarchy of selectedTemplate.hierarchies; let j = index">
						<div class="flex-class">
							<p class="hierarchy-header headers-placeholder">{{
								placeholderNonEditableHierarchy(hierarchy) }}</p>
							<div (click)="firstLevelAddStateChange('show')" class="plusBtnFirstLevel plusBtn"
								*ngIf="j === 0">
								<img src="../../../../../assets/images/plus.svg" alt="">
							</div>
						</div>
						<div class="inputBoxFirstLevel" *ngIf="canAddToFirstLevel && j === 0">
							<input type="text" placeholder="Level Name" [(ngModel)]="newFirstLevelName">
							<div class="btns">
								<button style="padding: 5px 10px;font-size: 10px; width: 107px;" mat-button
									(click)="firstLevelAddStateChange('hide')">Cancel</button>
								<button style="width: 107px; font-size: 10px; padding: 5px 10px;" mat-button
									[disabled]="newFirstLevelName.length <= 0" (click)="addNewFirstLevel()">Add
									Level</button>
							</div>
						</div>
					</div>
				</div>

				<mat-accordion>
					<div class="accordion_container"
						*ngIf="selectedTemplate.hierarchy && selectedTemplate.hierarchy[0]">
						<div *ngFor="let hierarchyOption of selectedTemplate.hierarchy[0].values; let i = index">
							<mat-expansion-panel [expanded]="shouldPanelExpand(i)" (afterExpand)="changeShowState(i)">
								<mat-expansion-panel-header>
									<div class="level-selection-container">
										<div class="flex-div"
											style="width: 200px; display: unset !important;white-space: pre;">
											<div class="flex-div"
												style="width: 200px; display: unset !important;white-space: pre;">
												<div class="flx2" style=" align-items: flex-start; flex-wrap: wrap;">
													<div *ngIf="canEditHierarchy" class="delete plusBtn"
													(click)="deleteLevel(0, hierarchyOption.orgIndex, hierarchyOption.value, i)">
													<img src="../../../../../assets/minus.png" alt="">
												</div>

													<span>
														{{ hierarchyOption.displayValue }}
													</span>

													<div class="icons">
														<div class="userIcon" (mouseenter)="showManagersList(hierarchyOption, true)"
															(mouseleave)="showManagersList(hierarchyOption, false)"
															(click)="viewLevelDetails(selectedTemplate.hierarchy[0].name, hierarchyOption, hierarchyOption.orgIndex)">
															<mat-icon class="level-details-btns">group</mat-icon>
														</div>

														<div *ngIf="canEditHierarchy" (click)="changeInputState('show', hierarchyOption.orgIndex); $event.stopPropagation()"
															class="plusBtn">
															<img src="../../../../../assets/images/plus.svg" alt="">
														</div>
													</div>

													<div class="managersList" *ngIf="hierarchyOption.showManagersList">
														<ul *ngIf="hierarchyOption?.managerNames?.length; else noMgrsAtLevel">
															<li *ngFor="let manager of hierarchyOption.managerNames">
																{{ manager.name }}
															</li>
														</ul>

														<ng-template #noMgrsAtLevel>
															<ul>
																<li>No Managers at this level</li>
															</ul>
														</ng-template>
													</div>

													<div style="position: unset; margin-top: 15px; flex-basis: 100%; display: none; max-width: 90%;" class="inputBox hidden" [attr.id]="'newLevel-' + hierarchyOption.orgIndex">
														<input type="text" placeholder="Level Name" [attr.id]="'newLevelName-' + hierarchyOption.orgIndex" (click)="$event.stopPropagation()">
														<div class="btns">
															<button style="padding: 5px 10px; font-size: 10px; width: 107px;"
																mat-button (click)="changeInputState('hide', hierarchyOption.orgIndex); $event.stopPropagation()">Cancel</button>
															<button style="width: 107px;font-size: 10px; padding: 5px 10px;" mat-button [disabled]="!isLevelNameAdded(hierarchyOption.orgIndex)" (click)="addHierarchyLevel(hierarchyOption.value, hierarchyOption.orgIndex, i); $event.stopPropagation()">Add Level</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</mat-expansion-panel-header>
								<div *ngIf="shouldShowInnerHierarchy[i]">
									<app-hierarchy-checkboxes [parentName]="hierarchyOption.value"
										[selectedTemplate]="selectedTemplate" [globalIndex]="hierarchyOption.orgIndex"
										[organisationHierarchy]="organisationHierarchy"
										[currentHierarchies]="currentHierarchies" [innerIndex]="0"
										[parents]="[hierarchyOption.value]" [totalHierarchies]="totalHierarchies"
										[canEditHierarchy]="canEditHierarchy" [organisationId]="organisationId"
										[localIndex]="hierarchyOption.orgIndex" [orgCode]="orgCode"
										(currentHierarchiesUpdateEvent)="updateCurrentHierarchies($event)" [rolesData]="rolesData" [accordionIndex]="i" (accordionUpdateEvent)="updateActiveAccordion($event)"></app-hierarchy-checkboxes>
								</div>
							</mat-expansion-panel>
						</div>
					</div>
				</mat-accordion>
			</div>
			<!-- </ng-template> -->
		</div>
	</ng-container>

	<ng-template #noTemplateAvailable>
		<p>No Hierarchy Available.</p>
	</ng-template>

</div>

<!-- <div class="create-hierarchy-body">
	<button mat-raised-button color="primary" (click)="saveOrganisationHierarchy()" class="create-template-btn">Save Organisation Hierarchy</button>
</div> -->